import UserPoints from './UserPoints';
export default UserPoints;
export * from './UserPoints';
